module.exports = "<p>\n  miscellaneous-fee-none-puc-student works!\n</p>\n"